module.exports = __webpack_public_path__ + "static/media/research.c71c288b.png";